// The review is transient. Only validated, confirmed badge assignments are stored.
export function selectedAccount(group, selections) {
  return Object.prototype.hasOwnProperty.call(selections, group.tacCustomerId) ? selections[group.tacCustomerId] : group.selectedUserId || null
}

export function importSelections(preview, selections) {
  return (preview.conflicts || []).map(group => ({ tacCustomerId: group.tacCustomerId, userId: selectedAccount(group, selections) }))
}

export function hasSelectionChanges(preview, selections) {
  return !!preview && (preview.conflicts || []).some(group => selectedAccount(group, selections) !== (group.selectedUserId || null))
}

export function reviewCounts(preview, selections) {
  if (!preview) return {}
  const counts = { manuallyAssignedBadges: 0, resolvedUserGroups: 0, ...preview.counts }
  for (const group of preview.conflicts || []) {
    const before = group.selectedUserId || null, after = selectedAccount(group, selections)
    if (before === after) continue
    const existing = id => { const candidate = group.candidates.find(user => user._id === id); return candidate ? candidate.existingBadges || 0 : 0 }
    const delta = Number(!!after) - Number(!!before)
    counts.badges += delta * group.badgeCount
    counts.users += delta
    counts.ambiguousUsers -= delta * group.badgeCount
    counts.manuallyAssignedBadges += delta * group.badgeCount
    counts.resolvedUserGroups += delta
    counts.newBadges += (after ? group.badgeCount - existing(after) : 0) - (before ? group.badgeCount - existing(before) : 0)
    counts.removedBadges += existing(before) - existing(after)
  }
  return counts
}
